import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About me`}</h2>
    <blockquote>
      <p parentName="blockquote">{`I am a Senior at Katy High School in Katy, Texas.`}</p>
    </blockquote>
    <p>{`You may know me from my Boy Scout flags fundraiser.  This is my business of scooping back yards.  The money from flags sends me to camp; I use scooping money to buy Legos`}{`®`}{`.`}</p>
    <p>{`I enjoy walking my own dog, Colt, each morning and evening.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      